var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB4842688541F4C6389Ef36Bfe42945D814Ca91F46Ea5B94E336D43Be5E0Cabcf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L6 6L1 11",
    stroke: "#424143",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4842688541F4C6389Ef36Bfe42945D814Ca91F46Ea5B94E336D43Be5E0Cabcf);
export default __webpack_public_path__ + "static/media/b4842688541f4c6389ef36bfe42945d814ca91f46ea5b94e336d43be5e0cabcf.c14c24f7b2549a10e12c544c46a3e913.svg";
export { ForwardRef as ReactComponent };